import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DeviceTypeOPEEnum} from "./DeviceTypeOPEEnum";

/**
 * O Inner Class
 */
class O {
}

class I {
  id!: number;
}


export class DelDeviceTypeCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(DeviceTypeOPEEnum.DelDeviceType);
    this.i = new I();
    this.o = new O();
  }
}
